import React from 'react';
import './HomePage.css';
import {Link} from "react-scroll";
import Feature from "../../components/Feature/Feature";

const HomePage = () => (
    <div>
        <div className="backgroundImage">
            <div className="overlay"></div>
            <div className="Intro">
                <h1>Connect with other gamers platform</h1>
                <p>Building personal gaming profile and professional networking, 
                    including posting articles and videos
                </p>
                <Link to="feature-section" smooth={true} duration={800} className="button">Read More</Link>
            </div>
        </div>
        <Feature/>
    </div>
)

export default HomePage;



/* <p>Whatever you are new to play games or struggling with climbing rank,
GameMeet helps you understand important concept and hone your skills so you can 
stand out from the crowd in fields like CSGO, League of Legends.
</p> */

//Thanks Florian Olivo and XX provide photo for us            
//<div className="">
//<a target="_blank" rel="noopener noreferrer" href='https://www.freepik.com/free-photos-vectors/people'>prostooleh</a> 
//</div>